import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuditLogsPaged } from "@/common/artemis-operations/audit";
import {
	AuditTable,
	auditTableListProps,
} from "@/components/audit/audit-table";
import { BaseContainer, BasePageContainer } from "@/components/base";
import { usePageTitle } from "@/contexts/page-title-context";

export const Route = createFileRoute("/_authenticated/$orgSlug/admin/audit")({
	component: AdminAuditPage,
});

function AdminAuditPage() {
	const { setTitle } = usePageTitle();
	useEffect(() => setTitle("Audit log"), [setTitle]);
	const list = useAuditLogsPaged();

	return (
		<BasePageContainer>
			<BaseContainer>
				<AuditTable {...auditTableListProps(list)} />
			</BaseContainer>
		</BasePageContainer>
	);
}
